import {
    andAllWhere,
    andWhere,
    buildQuery,
    CombinedFilter,
    noop,
    Ops,
    orderBy,
    OrderVariant,
    orWhere,
    page,
    where,
} from "@albatrosdeveloper/ave-utils-npm/lib/utils/query.util";
import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { IPagination, IPaginationResult, IPaginationResultFrequencies, IPaginationResultPagesList } from "app/common/interfaces";
import { RequestOptions } from "app/common/interfaces/options.interface";
import { AbstractService } from "app/services/abstract.service";
import { Observable } from "rxjs";
import { CreditApplicationAttributes } from "@albatrosdeveloper/ave-models-package";
import { CreditRequestFilters } from "../credit-application/interfaces/credit-request.model";
import { environment as env } from "../../../../../environments/environment.prod";
const apiUrl = env.API_AVE_CREDIT_URL;
const moduleName = "credit_application";

@Injectable({
    providedIn: "root",
})
export class CreditRequestService extends AbstractService<
    CreditApplicationAttributes,
    CreditApplicationAttributes,
    CreditApplicationAttributes
> {
    currentFilter: CombinedFilter<CreditApplicationAttributes>;

    constructor(http: HttpClient) {
        super(apiUrl, moduleName, http);
    }

    findAllWithCount(
        options: IPagination<CreditApplicationAttributes>,
        dataToFilter: CreditRequestFilters
    ): Observable<IPaginationResultFrequencies<CreditApplicationAttributes>> {
        const query = buildQuery<CreditApplicationAttributes>(
            where("_deleted", Ops.eq(false)),
            dataToFilter.requestIds && dataToFilter.requestIds.length > 0
                ? andAllWhere("id" as keyof CreditApplicationAttributes, Ops.in(...dataToFilter.requestIds))
                : noop(),
            options.search && options.search.trim() !== "" && !isNaN(Number(options.search))
                ? andWhere("id", Ops.eq(Number(options.search)))
                : noop(),
            options.search && options.search.trim() !== ""
                ? orWhere("businessPartner.name" as keyof CreditApplicationAttributes, Ops.like(options.search, "i"))
                : noop(),
            options.search && options.search.trim() !== ""
                ? orWhere("businessPartner.externalKeys.code" as keyof CreditApplicationAttributes, Ops.like(options.search, "i"))
                : noop(),
            options.search && options.search.trim() !== ""
                ? orWhere("user.first_name" as keyof CreditApplicationAttributes, Ops.like(options.search, "i"))
                : noop(),
            options.search && options.search.trim() !== ""
                ? orWhere("user.username" as keyof CreditApplicationAttributes, Ops.like(options.search, "i"))
                : noop(),
            dataToFilter.createdDateFrom || dataToFilter.createdDateTo
                ? andAllWhere(
                    "createdAt" as keyof CreditApplicationAttributes,
                    Ops.btwnDates(
                        dataToFilter.createdDateFrom ?? new Date(0),
                        dataToFilter.createdDateTo ?? new Date()
                    )
                )
                : noop(),
            dataToFilter.approvalDateFrom || dataToFilter.approvalDateTo
                ? andAllWhere(
                    "approvalDate" as keyof CreditApplicationAttributes,
                    Ops.btwnDates(
                        dataToFilter.approvalDateFrom ?? new Date(0),
                        dataToFilter.approvalDateTo ?? new Date()
                    )
                )
                : noop(),
            dataToFilter.statusId && dataToFilter.statusId.length > 0
                ? andAllWhere("statusId" as keyof CreditApplicationAttributes, Ops.in(...dataToFilter.statusId))
                : noop(),
            dataToFilter.statusERP && dataToFilter.statusERP.length > 0
                ? andAllWhere("statusERP" as keyof CreditApplicationAttributes, Ops.in(...dataToFilter.statusERP))
                : noop(),
            dataToFilter.isExtension !== null && dataToFilter.isExtension !== undefined
                ? andAllWhere("isExtension" as keyof CreditApplicationAttributes, Ops.eq(dataToFilter.isExtension))
                : noop(),
            dataToFilter.businessPartnerId && dataToFilter.businessPartnerId.length > 0
                ? andAllWhere("businessPartner._id" as keyof CreditApplicationAttributes, Ops.in(...dataToFilter.businessPartnerId))
                : noop(),
            dataToFilter.userId && dataToFilter.userId.length > 0
                ? andAllWhere("user._id" as keyof CreditApplicationAttributes, Ops.in(...dataToFilter.userId))
                : noop(),
            dataToFilter.approvalUserId && dataToFilter.approvalUserId.length > 0
                ? andAllWhere("approvalUser._id" as keyof CreditApplicationAttributes, Ops.in(...dataToFilter.approvalUserId))
                : noop(),
            dataToFilter.companyId && dataToFilter.companyId.length > 0
                ? andAllWhere("company._id" as keyof CreditApplicationAttributes, Ops.in(...dataToFilter.companyId))
                : noop(),
            dataToFilter.subRouteId && dataToFilter.subRouteId.length > 0
                ? andAllWhere("subRoute._id" as keyof CreditApplicationAttributes, Ops.in(...dataToFilter.subRouteId))
                : noop(),
            dataToFilter.customerType && dataToFilter.customerType.length > 0
                ? andAllWhere("businessPartner.types.code" as keyof CreditApplicationAttributes, Ops.in(...dataToFilter.customerType))
                : noop(),
            orderBy(
                (options.sort ?? "createdAt") as keyof CreditApplicationAttributes,
                options.sortDirection === "ASC" ? OrderVariant.Asc : OrderVariant.Desc
            ),
            page(options.currentPage ?? 1, options.limitPerPage ?? 50)
        );
        this.currentFilter = query;
        const API_URL = `${apiUrl}api/${moduleName}/report`;
        const body = { filter: query };
        return this.http.post<IPaginationResultFrequencies<CreditApplicationAttributes>>(API_URL, body);
    }
}
